import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Qualifica provvigioni", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Qualifica bloccata", -1)
const _hoisted_7 = { class: "scrollListContainer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Storico ")
const _hoisted_9 = { class: "text-cyan" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.provvigioniConfig.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProvvigioni) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSelectedProvvigioniChange && _ctx.onSelectedProvvigioniChange(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provvigioniConfig, (item, i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i,
                value: item
              }, _toDisplayString(item.codiceQualifica), 9, _hoisted_4))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedProvvigioni]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.pianoProvvigioni.isLocked) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.localValue.pianoProvvigioni.isLocked]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue.storicoPianoProvvigioni, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "scrollListItem d-flex justify-content-between",
              key: i
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$filters.date(item.date, "YYYY-MM-DD HH:mm")), 1),
              _createElementVNode("div", null, _toDisplayString(item.value.qualifica.codiceQualifica), 1)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}